"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.cLanguages = exports.cLanguagesEnglish = exports.cLanguageCodes = void 0;
exports.cLanguageCodes = {
    fr: 'fr',
    en: 'en',
    cy: 'cy',
    ee: 'ee',
    ja: 'ja',
    ms: 'ms',
    de: 'de',
    zh: 'zh',
    es: 'es'
};
exports.cLanguagesEnglish = (_a = {},
    _a[exports.cLanguageCodes.fr] = 'French',
    _a[exports.cLanguageCodes.en] = 'English',
    _a[exports.cLanguageCodes.cy] = 'Welsh',
    _a[exports.cLanguageCodes.ee] = 'Estonian',
    _a[exports.cLanguageCodes.ms] = 'Malay',
    _a[exports.cLanguageCodes.ja] = 'Japanese',
    _a[exports.cLanguageCodes.de] = 'German',
    _a[exports.cLanguageCodes.zh] = 'Chinese',
    _a[exports.cLanguageCodes.es] = 'Spanish',
    _a);
exports.cLanguages = (_b = {},
    _b[exports.cLanguageCodes.fr] = 'Français',
    _b[exports.cLanguageCodes.en] = 'English',
    _b[exports.cLanguageCodes.cy] = 'Cymraeg',
    _b[exports.cLanguageCodes.ee] = 'Eesti',
    _b[exports.cLanguageCodes.ms] = 'Melayu',
    _b[exports.cLanguageCodes.ja] = '日本語',
    _b[exports.cLanguageCodes.de] = 'Deutsch',
    _b[exports.cLanguageCodes.zh] = '中文',
    _b[exports.cLanguageCodes.es] = 'Español',
    _b);
